import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { FacilityContextService } from '../../../context/facility-context/facility-context.service'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { AsyncPipe } from '@angular/common'
import { WorkStationBrowserComponent } from '../work-station-browser/work-station-browser.component'
import { FacilityContextMenuComponent } from '../../../context/facility-context/facility-context-menu/facility-context-menu.component'
import { ElderToolbarColumnDirective } from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-work-station-browser-viewer',
  templateUrl: './work-station-browser-viewer.component.html',
  styleUrls: ['./work-station-browser-viewer.component.scss'],
  imports: [
    ElderToolbarColumnDirective,
    FacilityContextMenuComponent,
    WorkStationBrowserComponent,
    AsyncPipe,
  ],
})
export class WorkStationBrowserViewerComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly facilityId$: Observable<string>

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const facilityContextService = inject(FacilityContextService)

    this.facilityId$ = facilityContextService.facility$.pipe(map((facility) => facility.id))
  }
}
